<template>
    <div class="admin-permissiondefinition-editor">
        <div class="editor-toolbar">
            <DxButton icon="add" text="Neu" @click="createNew" />
            <DxButton icon="save" text="Speichern" type="default" @click="save" />
            <DxButton icon="trash" text="L�schen" :disabled="!permissionDefinition?._id" @click="remove" />
        </div>

        <DxForm v-if="permissionDefinition"
                :form-data="permissionDefinition"
                label-mode="outside"
                label-location="top"
                :col-count="2"
                class="admin-permissiondefinition-form">
            <DxSimpleItem data-field="key" :label="{text:'Key'}" editor-type="dxTextBox" :is-required="true" />
            <DxSimpleItem data-field="label" :label="{text:'Bezeichnung'}" editor-type="dxTextBox" />

            <DxSimpleItem data-field="area" :label="{text:'Bereich'}"  editor-type="dxTextBox" />
            <DxSimpleItem data-field="group" :label="{text:'Gruppe'}" editor-type="dxTextBox" />

            <DxSimpleItem data-field="action" :label="{text:'Aktion'}" editor-type="dxTextBox" />            

            <DxSimpleItem data-field="description" :label="{text:'Beschreibung'}" 
                          editor-type="dxTextArea"
                          :col-span="2"
                          :editor-options="{ minHeight: 120 }" />
        </DxForm>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import DxButton from 'devextreme-vue/button';
    import { DxForm, DxSimpleItem } from 'devextreme-vue/form';
    import permissionDefinitionApi from '../services/PermissionApi';

    export default defineComponent({
        components: {
            DxButton,
            DxForm,
            DxSimpleItem
        },
        emits: ['saved'],
        data() {
            return {
                permissionDefinition: null
            };
        },
        watch: {
            '$route.params.id': {
                immediate: true,
                async handler() {
                    await this.loadData();
                }
            }
        },
        methods: {
            async loadData() {
                const id = this.$route.params.id;

                if (!id || id === 'new') {
                    this.permissionDefinition = await permissionDefinitionApi.createNew({
                        Key: '',
                        Label: '',
                        Area: '',
                        Group: '',
                        Action: '',
                        Description: '',
                        SortOrder: 0
                    });
                    return;
                }

                this.permissionDefinition = await permissionDefinitionApi.get(id);
            },
            async createNew() {
                this.$router.push('/Admin/PermissionDefinitions/new');
            },
            async save() {
                const saved = await permissionDefinitionApi.save(this.permissionDefinition);
                this.permissionDefinition = saved;
                this.$emit('saved');

                if (saved._id && this.$route.params.id !== saved._id) {
                    this.$router.replace('/Admin/PermissionDefinitions/' + saved._id);
                }
            },
            async remove() {
                if (!this.permissionDefinition?._id)
                    return;

                await permissionDefinitionApi.delete(this.permissionDefinition._id);
                this.$emit('saved');
                this.$router.replace('/Admin/PermissionDefinitions/new');
            }
        }
    });
</script>

<style scoped>
    .admin-permissiondefinition-editor {
        display: grid;
        grid-template-columns: minmax(0,1fr);
        grid-template-rows: max-content minmax(0,1fr);
        gap: 10px;
        padding: 10px;
        background-color: #2a2a2a;
    }

    .editor-toolbar {
        display: flex;
        gap: 10px;
    }

    .admin-permissiondefinition-form {
        max-width: 1000px;
    }
</style>